"use client";

import { useSearchParams } from "next/navigation";
import { startTransition } from "react";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { Select } from "ui/widget/select";
import { ToggleButtonOption, ToggleButtons } from "ui/widget/toggle-buttons";

import { HoldingsInfo } from "../../../services/get-investor-holdings-info";
import { HoldingsInfoTable } from "./HoldingsInfoTable";

type Props = {
  investor: string;
  holdingsInfoOptions: ToggleButtonOption[];
  initialData: HoldingsInfo;
};

export const HoldingsInfoComponent = ({
  investor,
  holdingsInfoOptions,
  initialData,
}: Props) => {
  const searchParams = useSearchParams();
  const selectedCategoryIndex = +(
    searchParams.get("holdings-info-table-category-index") ?? "0"
  );
  const { updateQuery } = useUpdateQuery();

  const handleCategoryChange = (category: string) => {
    startTransition(() => {
      const index = holdingsInfoOptions.findIndex(
        (option) => option.value === category
      );
      updateQuery({
        name: "holdings-info-table-category-index",
        value: `${index}`,
      });
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <ToggleButtons
        className="hidden w-fit @md:flex"
        itemClassName="text-neutral-400"
        selectedItemClassName="text-sky-700"
        options={holdingsInfoOptions}
        value={holdingsInfoOptions[selectedCategoryIndex].value}
        onChange={handleCategoryChange}
        id="holdings-info-table-category"
      />
      <Select
        data={holdingsInfoOptions.map((option) => option.value)}
        value={holdingsInfoOptions[selectedCategoryIndex].value}
        onValueChange={handleCategoryChange}
        className="flex h-9 max-w-[200px] rounded-md @md:hidden"
        id="holdings-info-table-menu"
      />
      <HoldingsInfoTable
        key={`holdings-info-table-${selectedCategoryIndex}`}
        investor={investor}
        initialData={initialData}
        selectedCategoryIndex={selectedCategoryIndex}
      />
    </div>
  );
};
